import React, { useState } from 'react';

const Filters = ({ columns, onChange }) => {
  const [filters, setFilters] = useState([]); // Tableau de filtres

  // Ajouter un filtre vide
  const addFilter = () => {
    setFilters([...filters, { column: '', value: '' }]);
  };

  // Mettre à jour un filtre
  const updateFilter = (index, field, newValue) => {
    const newFilters = [...filters];
    newFilters[index][field] = newValue;
    setFilters(newFilters);
    onChange(newFilters); // Remonte les filtres au parent
  };

  // Supprimer un filtre
  const removeFilter = (index) => {
    const newFilters = filters.filter((_, i) => i !== index);
    setFilters(newFilters);
    onChange(newFilters); // Remonte les filtres au parent
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-theme-primary">
          <i className="fas fa-filter mr-2 text-theme-accent"></i>
          Filtres
        </h3>
        <button 
          onClick={addFilter}
          className="btn-theme-secondary text-sm"
        >
          <i className="fas fa-plus mr-2"></i>
          Ajouter un filtre
        </button>
      </div>
      
      {filters.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <i className="fas fa-filter text-4xl mb-2"></i>
          <p>Aucun filtre appliqué</p>
          <p className="text-sm">Cliquez sur "Ajouter un filtre" pour commencer</p>
        </div>
      ) : (
        <div className="space-y-3">
          {filters.map((filter, index) => (
            <div key={index} className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg">
              <div className="flex-1">
                <select
                  value={filter.column}
                  onChange={(e) => updateFilter(index, 'column', e.target.value)}
                  className="input-theme"
                >
                  <option value="">Sélectionner une colonne</option>
                  {columns.map((col) => (
                    <option key={col.value} value={col.value}>
                      {col.label}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="flex-1">
                <input
                  type="text"
                  placeholder="Valeur à rechercher"
                  value={filter.value}
                  onChange={(e) => updateFilter(index, 'value', e.target.value)}
                  className="input-theme"
                />
              </div>
              
              <button 
                onClick={() => removeFilter(index)}
                className="btn-theme-secondary text-red-600 hover:bg-red-50 hover:text-red-700"
              >
                <i className="fas fa-trash"></i>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Filters;
